import React from 'react'
import PropTypes from 'prop-types'
import { Layout } from '../../components'
import DynamicZone from '../../helpers/dynamicZone'

const Page = ({ pageContext }) => {
  // pageContext - Elementos pasados como parametros
  // data - Información obtenida de la query
  
  const { 
    pageId, 
    pageData,
    navbar,
    footerData
  } = pageContext

  const { body, pageMetadata, scripts } = pageData
  
  return (
    <Layout
      key={`page-${pageId}`}
      screenData={navbar && navbar}
      pageMetadata={pageMetadata}
      scriptSelect={scripts}
      footerData={footerData}
    >
      <DynamicZone components={body} />
    </Layout>
  )
}

Page.propTypes = {
  pageContext: PropTypes.object.isRequired,
}

export default Page